import { createAction, props } from '@ngrx/store';

import {
  SummaryReportSettingsAddToDashboardModel,
  SummaryReportSettingsModel,
  SummaryReportSettingsModelBase,
  SummaryType,
} from '@main-application/shared/services/summary-report-settings.service';

export const setSummaryReportSettings = createAction(
  '[SummaryReportSettings] Set Summary Settings',
  props<{
    summaryType: SummaryType;
    initial: SummaryReportSettingsModel;
    modified: SummaryReportSettingsModel;
  }>()
);

export const setModifiedReportSettings = createAction(
  '[SummaryReportSettings] Set Modified Summary Settings',
  props<{
    summaryType: SummaryType;
    modified: SummaryReportSettingsModel;
  }>()
);

export const resetSummaryReportFilters = createAction(
  '[SummaryReportSettings] Reset Summary Filters',
  props<{
    summaryType: SummaryType;
  }>()
);

export const loadSummaryReportSettings = createAction('[SummaryReportSettings] Load All');

export const loadSummaryReportSettingsSuccess = createAction(
  '[SummaryReportSettings] Load All Success',
  props<{ settings: SummaryReportSettingsModel[] }>()
);

export const loadSummaryReportSettingsFailure = createAction(
  '[SummaryReportSettings] Load All Failure',
  props<{ error: any }>()
);

export const addSummaryReportSetting = createAction(
  '[SummaryReportSettings] Add Setting',
  props<{ setting: SummaryReportSettingsModelBase }>()
);

export const addSummaryReportSettingSuccess = createAction(
  '[SummaryReportSettings] Add Setting Success',
  props<{ setting: SummaryReportSettingsModel }>()
);

export const addSummaryReportSettingFailure = createAction(
  '[SummaryReportSettings] Add Setting Failure',
  props<{ error: any }>()
);

export const updateSummaryReportSetting = createAction(
  '[SummaryReportSettings] Update Setting',
  props<{ id: number; setting: SummaryReportSettingsModel }>()
);

export const updateSummaryReportSettingSuccess = createAction(
  '[SummaryReportSettings] Update Setting Success',
  props<{ setting: SummaryReportSettingsModel }>()
);

export const updateSummaryReportSettingFailure = createAction(
  '[SummaryReportSettings] Update Setting Failure',
  props<{ error: any }>()
);

export const downloadSummaryReport = createAction(
  '[SummaryReportSettings] Download Summary Report',
  props<{
    settings: SummaryReportSettingsModel;
    portfolioId?: number;
    propertyIds?: string;
    collectionIds?: string;
    queryType?: number;
    dateFieldsLookupMode?: number;
    includeUnscheduled?: boolean;
    excludeBoardTickets?: boolean;
    periodDateSearchFields?: number;
    isResident?: boolean;
    reportView?: number;
  }>()
);

export const downloadSummaryReportSuccess = createAction('[SummaryReportSettings] Download Summary Report Success');

export const downloadSummaryReportFailure = createAction(
  '[SummaryReportSettings] Download Summary Report Failure',
  props<{ error: any }>()
);

export const cancelDownloadSummaryReport = createAction('[SummaryReportSettings] Cancel Download Summary Report');

export const deleteSummaryReportSetting = createAction(
  '[SummaryReportSettings] Delete Setting',
  props<{ id: number }>()
);

export const deleteSummaryReportSettingSuccess = createAction(
  '[SummaryReportSettings] Delete Setting Success',
  props<{ id: number }>()
);

export const deleteSummaryReportSettingFailure = createAction(
  '[SummaryReportSettings] Delete Setting Failure',
  props<{ error: any }>()
);

export const addToDashboard = createAction(
  '[SummaryReportSettings] Add To Dashboard',
  props<{ model: SummaryReportSettingsAddToDashboardModel }>()
);

export const addToDashboardSuccess = createAction(
  '[SummaryReportSettings] Add To Dashboard Success',
  props<{ roleId: number; summarySettingsReportIds: number[] }>()
);

export const addToDashboardFailure = createAction(
  '[SummaryReportSettings] Add To Dashboard Failure',
  props<{ error: any }>()
);

// Remove
export const removeFromDashboard = createAction(
  '[SummaryReportSettings] Remove From Dashboard',
  props<{ model: SummaryReportSettingsAddToDashboardModel }>()
);

export const removeFromDashboardSuccess = createAction(
  '[SummaryReportSettings] Remove From Dashboard Success',
  props<{ roleId: number; summarySettingsReportIds: number[] }>()
);

export const removeFromDashboardFailure = createAction(
  '[SummaryReportSettings] Remove From Dashboard Failure',
  props<{ error: any }>()
);
